import { gql } from "@outschool/ui-apollo";

export const getS3FileUploadUrlMutation = gql`
  mutation getS3FileUploadUrl($fileName: String, $accessTier: FileAccessTier) {
    getS3FileUploadUrl(fileName: $fileName, accessTier: $accessTier) {
      uploadUrl
      cdnUrl
      newFileName
    }
  }
`;
